import Router from '../libs/Router';

const router = new Router();

export default router;
